module.exports = __webpack_public_path__ + "static/media/loginBg.a6d77a64.jpg";